var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowXoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 67,
    viewBox: "0 0 201 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1 33.2H66.7L55.6 22.2C54.1 20.7 53.3 18.8 53.3 16.7C53.3 14.6 54.1 12.7 55.6 11.2C58.6 8.20001 63.6 8.20001 66.6 11.2L77.7 22.3L77.6 22.9L67.4 33.2L77.7 43.5V44.3L66.7 55.3C63.7 58.3 58.7 58.3 55.7 55.3C52.7 52.3 52.7 47.3 55.7 44.3L66.7 33.3L67.1 33.2Z",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 44.7L88.7 33.3L99.9 22.1C100.3 21.6 100.7 21.2 101.1 20.8C104.3 16.7 103.8 13.3 101 10.5C99.5 9 97.4 8 95.4 8C95.4 8 92.2 8 89.7 10.4C89.6 10.5 89.4 10.6 89.3 10.8L77.7 22.3L66.7 33.3L77.7 44.3L89.2 55.8C89.4 56 89.6 56.2 89.9 56.4C93.8 59.6 98.5 59.2 101.3 56.4C104.1 53.6 104 49.2 100.8 45.5C100.6 45.2 100.4 45 100.2 44.7Z",
    fill: "#BDC5D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8 0C105.3 0 97.6 3.2 91.7 8.4C91 9 90.4 9.6 89.7 10.3C91.1 9.1 92.9 8.4 94.8 8.4C96.9 8.4 98.8 9.2 100.3 10.7C103 13.4 103.3 17.7 101.1 20.7C101.6 20.2 102.1 19.8 102.6 19.4C105.7 16.9 109.5 15.4 113.8 15.4C123.6 15.4 131.6 23.4 131.6 33.2C131.6 43 123.6 51 113.8 51C109.6 51 105.7 49.5 102.6 47C102 46.5 101.4 45.9 100.8 45.3C103.2 48.4 103 52.8 100.2 55.6C97.4 58.4 92.9 58.6 89.9 56.2C90.5 56.8 91 57.3 91.6 57.9C97.5 63.1 105.2 66.3 113.7 66.3C132.1 66.3 147 51.4 147 33.1C147 14.8 132.2 0 113.8 0Z",
    fill: "#7B878D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.4,
    height: 66.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowXoGray);
export default __webpack_public_path__ + "static/media/flow-xo-gray.528174195eaee8908dcc13ea464152b3.svg";
export { ForwardRef as ReactComponent };